import { useMemo } from 'react'

import {
  isPrivacyCenterContentLoading,
  resolveRemoteDataScreenStatus,
} from 'common/query-screen-status'
import { useAppContext } from 'contexts/app-context/hooks/useAppContext'
import { useGetPurposes } from 'hooks/useGetPurposes'
import { isValidProductId } from 'pages/product-details/services/ProductDetails.services'
import { useParams } from 'react-router-dom'

export function useProductBr() {
  const { purposes, purposesStatus, isPurposesError } = useGetPurposes()

  const { privacyCenterContent, isAppLoading, isAppError } = useAppContext()

  const { productId } = useParams()

  const entity = privacyCenterContent?.entity

  const validProductId = isValidProductId(entity, productId)

  const isActive = !!privacyCenterContent?.components?.products?.isActive

  const productsContent = privacyCenterContent?.components?.products?.content

  const productContent =
    validProductId && productsContent ? productsContent[validProductId] : undefined

  const purpose = purposes?.find((p) => p.id === validProductId)

  const isContentLoading = isPrivacyCenterContentLoading(isAppLoading, !!productsContent)

  const screenStatus = useMemo(
    () =>
      resolveRemoteDataScreenStatus({
        queryStatus: purposesStatus,
        isQueryError: isAppError || isPurposesError || !isActive,
        hasRequiredData: !!productContent && !!purpose && !!entity,
        isContentLoading,
      }),
    [
      purposesStatus,
      isAppError,
      isPurposesError,
      isActive,
      productContent,
      purpose,
      entity,
      isContentLoading,
    ],
  )

  return {
    screenStatus,
    isActive,
    purpose,
    productId,
    entity,
    productContent,
  }
}
